<!--
 * @Author: wumao
 * @Date: 2021-11-24 16:15:02
 * @LastEditors: yeqing
 * @LastEditTime: 2022-05-13 10:57:43
 * @Description: 第一页
-->
<template>
  <Page page="01" :companyName="resultData.orgName">
    <div class="wrapper">
      <div class="item">
        <Title text="海南省专精特新企业雏鹰发展计划" />
        <div class="info">
          《海南省促进中小企业“专精特新”发展工作实施方案（修订）》提出，围绕海南省旅游业、现代服务业、高新技术产业三大主导产业，以及热带特色高效农业（即“3+1”产业），引导海南省中小企业走“专精特新”发展之路，提升自主创新能力、加快转型升级，促进中小企业专业化、精细化、特色化、创新型发展，形成滚动发展梯度培育格局。设立“专精特新”中小企业库，每年筛选一批主营业务突出、竞争力强、成长性好的中小企业入库，通过培育促进企业增品种、提品质、创品牌，大幅提高海南省“专精特新”中小企业的数量、整体素质和发展质量。在此基础上，打造一批专注于细分市场的“小巨人”企业，在海南省树立中小企业发展的标杆和典型，引导促进海南省中小企业持续健康发展。到2025年，滚动培育300家以上省级“专精特新”中小企业，30家以上国家“专精特新’小巨人’”企业，总结推广一批中小企业“专精特新”发展模式，打造一批在技术、市场、产品、管理等方面具有持续竞争力的中小企业群体。
        </div>
      </div>
      <div class="item">
        <Title text="海南省专精特新企业政策宏利" />
        <div class="info">
          <div>1、加强财政扶持：</div>
          <div>（1）推荐专精特新“小巨人”企业申报国家重点支持资金。</div>
          <div>（2）鼓励市县结合本地实际给予财政支持。</div>
          <div>2、加强金融服务：</div>
          <div>
            （1）海南股权交易中心设立“专精特新板”，支持符合条件的“专精特新”企业在“专精特新板”挂牌展示交易，争取在资本市场直接融资。
          </div>
          <div>
            （2）联合金融机构制定“海南省‘专精特新’中小企业融资促进方案”，面向“专精特新”及“小巨人”企业推出“专精特新”系列专属产品，争取信贷资金持续支持。
          </div>
          <div>
            （3）利用财政资金贴息、补助、奖励、风险补偿等多种方式，鼓励银行、融资性担保机构、保险机构等为“专精特新”企业提供融资服务。
          </div>
          <div>3、加强品牌宣传：</div>
          <div>
            利用媒体和有关网站，开设“海南省‘专精特新’培育企业网上展示馆”，提高“专精特新”企业品牌效应。
          </div>
          <div>4、加强公共服务：</div>
          <div>
            （1）支持“专精特新”企业参加中国国际中小企业博览会、APEC中小企业技术交流暨展会以及各种专业性、行业性展会等，着力提升企业知名度、产品广誉度、品牌影响力。
          </div>
          <div>
            （2）遴选“专精特新”企业高级管理人员参加中小企业经营管理领军人才培训。
          </div>
          <div>
            （3）发挥国家重点支持公共服务示范平台资金作用，鼓励科研院所、研发机构、科创中心等科研机构与“专精特新”企业开展产学研合作，支持“专精特新”企业提升创新能力。
          </div>
          <div>
            （4）统筹整合优势资源，搭建“专精特新”企业对接平台，实现信息畅通、资源共享。
          </div>
          <div>
            （5）健全“专精特新”企业诉求机制，统筹协调有关部门，及时解决企业困难和问题。
          </div>
        </div>
      </div>
    </div>
  </Page>
</template>

<script>
import Page from "./Page.vue";
import Title from "./Title.vue";
export default {
  props: {
    resultData: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Page,
    Title,
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  .item {
    font-size: 14px;
    color: #333;
    margin-bottom: 30px;
    .info {
      margin-left: 20px;
      margin-top: 30px;
      line-height: 25px;
    }
  }
}
</style>
